<ion-header
  class="ion-no-border"
  [class.mobile]="platform === platformRef.mobile"
  [class.tablet]="platform === platformRef.tablet"
  [ngClass]="
    platform !== platformRef.desktop
      ? platform === platformRef.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar>
    <div class="header-stack">
      <ion-buttons slot="end" *ngIf="platform === platformRef.desktop">
        <ion-button data-cy="import-order-modal-button" (click)="dismiss()">
          <ion-icon
            slot="icon-only"
            name="close-outline"
            data-cy="import-order-icon"
          ></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-label
        [class.mobile]="platform === platformRef.mobile"
        [class.tablet]="platform === platformRef.tablet"
      >
        {{ 'i18n.menuProfitPro.uploadRecipeImageModal.title' | translate }}
      </ion-label>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content
  [ngClass]="
    platform !== platformRef.desktop
      ? platform === platformRef.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
      : 'ion-content-modal-desktop'
  "
>
  <div
    class="content-title"
    [class.mobile]="platform === platformRef.mobile"
    [class.tablet]="platform === platformRef.tablet"
  >
    {{ 'i18n.menuProfitPro.uploadRecipeImageModal.content' | translate }}
    <ion-icon
      id="hover-file-trigger"
      data-cy="file-information-icon"
      name="information-circle-outline"
      color="success"
      class="info-icon"
    ></ion-icon>
  </div>

  <ion-popover
    data-cy="file-information-popover"
    class="accepted-file-types-popover"
    mode="ios"
    trigger="hover-file-trigger"
    trigger-action="hover"
    (didPresent)="closePopoverOnBlur()"
    (didDismiss)="removeWindowListener()"
  >
    <ng-template>
      <app-accepted-file-types-popover
        [fileTypesList]="acceptedFileTypes"
      ></app-accepted-file-types-popover>
    </ng-template>
  </ion-popover>
  <ion-card
    class="image-container"
    [class.mobile]="platform === platformRef.mobile"
    [class.tablet]="platform === platformRef.tablet"
    [ngClass]="{ 'error-card': uploadError }"
  >
    <!-- Loading Indicator -->
    <div class="loading-container" *ngIf="isLoading">
      <ion-spinner name="circles" color="primary"></ion-spinner>
      <p>{{ 'i18n.common.loading' | translate }}</p>
    </div>

    <!-- Image Preview -->
    <div
      class="image-preview-container"
      *ngIf="(!!imagePreview || !!currentSRC) && !isLoading"
    >
      <img
        [src]="!!imagePreview ? imagePreview : currentSRC"
        class="image-preview"
      />
    </div>
    <!-- Replace Image Button -->
    <ion-button
      *ngIf="(!!imagePreview || !!currentSRC) && !isLoading"
      fill="clear"
      color="success"
      class="replace-button"
      (click)="takePhoto()"
    >
      {{ 'i18n.menuProfitPro.uploadRecipeImageModal.replaceImage' | translate }}
    </ion-button>

    <!-- Take Photo Button -->
    <ion-button
      *ngIf="!isLoading && !imagePreview && !currentSRC"
      expand="block"
      fill="outline"
      color="primary"
      (click)="takePhoto()"
      class="upload-button"
      [disabled]="isLoading"
    >
      <div class="stacked-content">
        <ion-icon name="camera" slot="start"></ion-icon>
        <span>{{
          'i18n.menuProfitPro.uploadRecipeImageModal.addPhoto' | translate
        }}</span>
      </div>
    </ion-button>
  </ion-card>

  <ion-text
    color="danger"
    *ngIf="uploadError"
    class="upload-error-text"
    [class.mobile]="platform === platformRef.mobile"
    [class.tablet]="platform === platformRef.tablet"
  >
    {{ uploadError | translate }}
  </ion-text>
</ion-content>

<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        [ngClass]="
          platformService?.platformType ===
          platformService?.platformEnum?.mobile
            ? 'usf-outline-green-mobile-modal-button'
            : 'usf-outline-green-dsktp-tblt-modal-button'
        "
        (click)="dismiss()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        [ngClass]="
          platformService?.platformType ===
          platformService?.platformEnum?.mobile
            ? 'usf-fill-green-mobile-modal-button'
            : 'usf-fill-green-dsktp-tblt-modal-button'
        "
        [disabled]="!selectedFile || !base64Image || isLoading || uploadError"
        (click)="saveAndSendToS3()"
      >
        {{ 'i18n.common.save' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
